import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PPMU_STANDALONE_PAGE_EXPERIMENT = defineFcm('ppmu_standalone_page_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'PPMU',
		description: 'This FCM config controls the PPMU standalone page experiment',
		import: false,
		template: {
			experimentName: '',
		},
	});
